export enum ApplicationEnum {
  REPO_LEND = 'REPO_LEND',
  CLEARING_HUB = 'CLEARING_HUB',
  LIMIT_MANAGER = 'LIMIT_MANAGER',
  RELEASE_PAGE = 'RELEASE_PAGE',
  ADMIN_DASHBOARD_SERVER = 'ADMIN_DASHBOARD_SERVER',
  AUTHENTICATOR = 'AUTHENTICATOR'
}
